(function($) { 
// Preserve the original jQuery "swing" easing as "jswing"
$.easing.jswing = $.easing.swing;

var pow = Math.pow,
	sqrt = Math.sqrt,
	sin = Math.sin,
	cos = Math.cos,
	PI = Math.PI,
	c1 = 1.70158,
	c2 = c1 * 1.525,
	c3 = c1 + 1,
	c4 = ( 2 * PI ) / 3,
	c5 = ( 2 * PI ) / 4.5;

// x is the fraction of animation progress, in the range 0..1
function bounceOut(x) {
	var n1 = 7.5625,
		d1 = 2.75;
	if ( x < 1/d1 ) {
		return n1*x*x;
	} else if ( x < 2/d1 ) {
		return n1*(x-=(1.5/d1))*x + 0.75;
	} else if ( x < 2.5/d1 ) {
		return n1*(x-=(2.25/d1))*x + 0.9375;
	} else {
		return n1*(x-=(2.625/d1))*x + 0.984375;
	}
}

$.extend( $.easing,
{
	def: 'easeOutQuad',
	swing: function (x) {
		return $.easing[$.easing.def](x);
	},
	easeInQuad: function (x) {
		return x * x;
	},
	easeOutQuad: function (x) {
		return 1 - ( 1 - x ) * ( 1 - x );
	},
	easeInOutQuad: function (x) {
		return x < 0.5 ?
			2 * x * x :
			1 - pow( -2 * x + 2, 2 ) / 2;
	},
	easeInCubic: function (x) {
		return x * x * x;
	},
	easeOutCubic: function (x) {
		return 1 - pow( 1 - x, 3 );
	},
	easeInOutCubic: function (x) {
		return x < 0.5 ?
			4 * x * x * x :
			1 - pow( -2 * x + 2, 3 ) / 2;
	},
	easeInQuart: function (x) {
		return x * x * x * x;
	},
	easeOutQuart: function (x) {
		return 1 - pow( 1 - x, 4 );
	},
	easeInOutQuart: function (x) {
		return x < 0.5 ?
			8 * x * x * x * x :
			1 - pow( -2 * x + 2, 4 ) / 2;
	},
	easeInQuint: function (x) {
		return x * x * x * x * x;
	},
	easeOutQuint: function (x) {
		return 1 - pow( 1 - x, 5 );
	},
	easeInOutQuint: function (x) {
		return x < 0.5 ?
			16 * x * x * x * x * x :
			1 - pow( -2 * x + 2, 5 ) / 2;
	},
	easeInSine: function (x) {
		return 1 - cos( x * PI/2 );
	},
	easeOutSine: function (x) {
		return sin( x * PI/2 );
	},
	easeInOutSine: function (x) {
		return -( cos( PI * x ) - 1 ) / 2;
	},
	easeInExpo: function (x) {
		return x === 0 ? 0 : pow( 2, 10 * x - 10 );
	},
	easeOutExpo: function (x) {
		return x === 1 ? 1 : 1 - pow( 2, -10 * x );
	},
	easeInOutExpo: function (x) {
		return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
			pow( 2, 20 * x - 10 ) / 2 :
			( 2 - pow( 2, -20 * x + 10 ) ) / 2;
	},
	easeInCirc: function (x) {
		return 1 - sqrt( 1 - pow( x, 2 ) );
	},
	easeOutCirc: function (x) {
		return sqrt( 1 - pow( x - 1, 2 ) );
	},
	easeInOutCirc: function (x) {
		return x < 0.5 ?
			( 1 - sqrt( 1 - pow( 2 * x, 2 ) ) ) / 2 :
			( sqrt( 1 - pow( -2 * x + 2, 2 ) ) + 1 ) / 2;
	},
	easeInElastic: function (x) {
		return x === 0 ? 0 : x === 1 ? 1 :
			-pow( 2, 10 * x - 10 ) * sin( ( x * 10 - 10.75 ) * c4 );
	},
	easeOutElastic: function (x) {
		return x === 0 ? 0 : x === 1 ? 1 :
			pow( 2, -10 * x ) * sin( ( x * 10 - 0.75 ) * c4 ) + 1;
	},
	easeInOutElastic: function (x) {
		return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
			-( pow( 2, 20 * x - 10 ) * sin( ( 20 * x - 11.125 ) * c5 )) / 2 :
			pow( 2, -20 * x + 10 ) * sin( ( 20 * x - 11.125 ) * c5 ) / 2 + 1;
	},
	easeInBack: function (x) {
		return c3 * x * x * x - c1 * x * x;
	},
	easeOutBack: function (x) {
		return 1 + c3 * pow( x - 1, 3 ) + c1 * pow( x - 1, 2 );
	},
	easeInOutBack: function (x) {
		return x < 0.5 ?
			( pow( 2 * x, 2 ) * ( ( c2 + 1 ) * 2 * x - c2 ) ) / 2 :
			( pow( 2 * x - 2, 2 ) *( ( c2 + 1 ) * ( x * 2 - 2 ) + c2 ) + 2 ) / 2;
	},
	easeInBounce: function (x) {
		return 1 - bounceOut( 1 - x );
	},
	easeOutBounce: bounceOut,
	easeInOutBounce: function (x) {
		return x < 0.5 ?
			( 1 - bounceOut( 1 - 2 * x ) ) / 2 :
			( 1 + bounceOut( 2 * x - 1 ) ) / 2;
	}
});

})(jQuery);

function mtMap(id, config) {
	
	if (jQuery('#'+id).length>0) {
		var myLatlng = new google.maps.LatLng(''+config.lat, ''+config.lng);
		var myOptions = {
			zoom: config.zoom,
			disableDefaultUI: config.disableDefaultUI,
			center: myLatlng,
			mapTypeId: config.type,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.DEFAULT
			}
		};
		var map = new google.maps.Map(document.getElementById(id), myOptions);

		var createMarker = function(i){
			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(''+config.markers[i].lat, ''+config.markers[i].lng),
				map: map,
				title: config.markers[i].title,
				animation: google.maps.Animation.DROP,
				icon: SHORTCODES_PLUGIN_DIR+'/dist/images/ui/marker.png'
			});

			if( config.markers[i].description.length || config.markers[i].title.length) {
				var infoWindow = new google.maps.InfoWindow({
					content:  '<h4>'+config.markers[i].title+'</h4><p>'+config.markers[i].description.replace(/(\n)/g, "<br />")+'</p>'
				});

				google.maps.event.addListener(marker, "click", function(event) {
					infoWindow.open(map, marker);
				});

				google.maps.event.addListener(map, "click", function(event) {
					infoWindow.close();
				});			
			}
		};
		
		for (var i in config.markers) {
			
			createMarker(i);
		}
	}
}

jQuery(function($){
	
	/* Sliders */
	
	// Nivo Slider
	$('.nivo-slider').each(function(){
		var slider = $(this);
		var sliderContainer = slider.parent();
		$('.mt-slide-content', sliderContainer).eq(0).addClass('current');
		slider.nivoSlider({
			effect: 'random',
			slices:  '10',
			animSpeed: '200', // transition speed
			pauseTime: '6500',
			directionNav: 'on',
			controlNav: 'on',
			bgcolors: ['#ffffff','#000000','#080a0c'],
			beforeChange: function(){

				$('.current', sliderContainer).stop().animate({left:0, opacity:0},
				{
					easing: 'easeOutSine',
					duration: 400,
					queue: false,
					complete: function(){
						$(this).removeClass('current');
					}
				});

			},

			afterChange: function(){
				var currentSlide = slider.data('nivo:vars').currentSlide;
				var lastSlide = slider.data('nivo:vars').lastSlide;

				var currentContent = $('.mt-slide-content', sliderContainer).eq(currentSlide).addClass('current');

	//			jQ('.mt-slide-content', sliderContainer).not(currentContent).hide();

				currentContent.css({opacity:0, left: 120}).animate({left: 80, opacity: 1},{easing: 'easeInSine', duration:400, queue: false});

/*
				var slideTitle = jQ('.slide-title', newSliderBox);
				var slideContent = jQ('.slide-content', newSliderBox);

				newSliderBox.css({height: slideTitle.outerHeight()+slideContent.outerHeight()+10});

				slideContent.css({top:460, opacity:0});
				slideTitle.css({opacity:0, top: -460}).stop().animate({opacity:1, top:13},{easing: 'easeInSine', duration:inventSliderConfig.animSpeed, queue: false});
				slideContent.animate({opacity:0},{duration:100, queue: false, complete:function(){
					jQ(this).animate({opacity:1, top:slideTitle.outerHeight()+19},{easing: 'easeInSine', duration:inventSliderConfig.animSpeed});
				}});
				newSliderBox.animate({opacity:1},{duration:inventSliderConfig.animSpeed, queue: false})
*/
			},
			afterLoad: function(){

				$('.mt-slide-content', sliderContainer).mouseenter(function(){
					slider.data('nivo:vars').stop = true;

				});
				
				$('.mt-slide-content', sliderContainer).mouseleave(function(){
					slider.data('nivo:vars').stop = false;

				});
			}		
		});	
	});
	
	
	// Rainbow Slider
	if($('.mt-rainbow-slider-container').length) {
		$('.mt-rainbow-slider-container').rainbowSlider();
	}

	$('.mt-scrolltotop').click(function(){
		$.scrollTo(0,600);
		return false;
	});

	$('.mt-image-effect-arrow').hover(function(){
		$('img', this).stop().animate({'border-top-left-radius':'15px', 'border-bottom-right-radius':'15px', opacity:0.4});
		$('.mt-image-icon', this).stop().animate({left: 0});
	}, function(){
		$('img', this).stop().animate({'border-top-left-radius':'0px', 'border-bottom-right-radius':'0px', opacity:1});
		$('.mt-image-icon', this).stop().animate({left: '-100%'});
	});
	
	/* TABS */
	
	if(typeof($.tools)!=='undefined') {
		$.tools.tabs.addEffect("rainbow-slide", function(tabIndex, done) {
			var panes = this.getPanes();
			var $$ = panes.eq(tabIndex);
			var parentNode = $$.parent();
			var h = $$.height();

			if(parentNode.height()>h) {

				panes.stop().css({zIndex:-1}).animate({opacity:0},400);
				$$.stop().css({zIndex:2}).animate({opacity:1}, 400, function(){
					parentNode.stop().animate({height: h}, 400);
				});
			} else {
				parentNode.stop().animate({height: h}, 400, function(){
					panes.stop().css({zIndex:-1}).animate({opacity:0},400);
					$$.stop().css({zIndex:2}).animate({opacity:1}, 400);
				});
			}
			done.call();
		});

		$(".mt-tabs").each(function(){

			$('>ul', this).tabs($('.mt-tabs-contents>div', this), {
				effect: 'rainbow-slide', 
				current: 'current',
				initialIndex: $('>ul li.current', this).length ? $('>ul li.current', this).index() : 0,
				initialEffect: true
			});
		});
	}
	
	/* ACCORDIONS */

	$('.mt-accordion').each(function(){
		var c = $(this),
			activeIndex,
			h= 0;

		$('.mt-accordion-title',c).each(function(i){
			var d = $(this).next();
			var title = this;
			
			function doAnimation(title){
					if(d.height()>0){
						h = 0;
					} else {

						if(!d.is(':animated')) {
							d.css('display','block');
							d.height('auto');
							h = d.height();
							d.height(0);
						}
					}

					d.stop().animate({
						'height':h
					},'600', function(){
						if(h===0) {
							$(this).css({display:'none'});
						}
					});

					if (h>0) {
						$(title).addClass('active');
					} else {
						$(title).removeClass('active');
					}
			}
							
			if($(this).hasClass('active')){
				doAnimation(title);
			} else
				$(this).next().css('display','none');
			
			$(this).click(function(){

				if(!c.hasClass('mt-accordion-multiple') && $('.active',c).length){
					var a = $('.active',c);
					activeIndex = a.index();
					
					if(activeIndex === $(title, c).index()){
						doAnimation(title);
					} else {
					
						a.removeClass('active').next().stop().animate({
							'height':0
						},'600', function(){
							$(this).css('display','none');
							doAnimation(title);
						});
					}
				}
				else
					doAnimation(title);

			});

		});

	});
	
		
	/* CAROUSELS */

	$('.jcarousel').jcarousel({scroll: 1});
	
});